import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getCarChassisPlate } from "../../../store/vehiclesApap/actions";
export var useGetCarChassisPlate = function (trigger, body) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseCarChassisPlate: state.Vehicles.responseCarChassisPlate,
        errorCarChassisPlate: state.Vehicles.errorCarChassisPlate,
        loadingCarChassisPlate: state.Vehicles.loadingCarChassisPlate,
    }); }), responseCarChassisPlate = _a.responseCarChassisPlate, errorCarChassisPlate = _a.errorCarChassisPlate, loadingCarChassisPlate = _a.loadingCarChassisPlate;
    useEffect(function () {
        if (trigger) {
            dispatch(getCarChassisPlate({
                body: body,
            }));
        }
    }, [trigger, body === null || body === void 0 ? void 0 : body.data.type]);
    return {
        responseCarChassisPlate: responseCarChassisPlate,
        errorCarChassisPlate: errorCarChassisPlate,
        loadingCarChassisPlate: loadingCarChassisPlate,
    };
};
